import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product } from 'app/models/product.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportesService {
  constructor(private http: HttpClient) {}

  getProductosSinStock(): Observable<Product | any> {
    return this.http.get(environment.apiUrl + 'reportes/stock/sin-stock');
  }
}
